/// <reference types="@types/google.maps" />
import type { Location } from '@bringg/types/types/location';

export const encodePath = (location: Location): string => {
	const googleLocations = [{ lat: location.lat, lng: location.lng }];
	return google.maps.geometry.encoding.encodePath(googleLocations);
};

export const decodePath = (encodedLocation: string): Location[] => {
	const googleLocations = google.maps.geometry.encoding.decodePath(encodedLocation);
	return googleLocations.map(googleLocation => ({
		lat: googleLocation.lat(),
		lng: googleLocation.lng()
	}));
};
